// @flow

import { actions as formActions, SubmissionError } from 'gandi.react-form';
import {
  createResource,
  type ActionReturn,
  type Resource,
} from '@gandi/redux-resource';
import type { TranslatorProps } from '@gandi/translate';

import type { Dispatch, ResourceThunkAction } from '../../types';

export const resourceCampaigns: Resource<> = createResource(
  'unsubscription-campaigns'
);

type DeleteNotificationSubscribersCompaignAction<R> = (
  token: string,
  campaign: string
) => R;

export const deleteNotificationSubcribersCompaign: DeleteNotificationSubscribersCompaignAction<
  ResourceThunkAction
> =
  (token, campaign): ((dispatch: Dispatch) => ActionReturn) =>
  dispatch =>
    dispatch(
      resourceCampaigns.deleteOne(
        `/newsletter-anonymous/campaigns/${campaign}/unsubscribe/${token}`
      )
    );

// Server-side POST
export function submitUnsubscriptionComplaignForm(
  values: {| unsubscription_choice: string |},
  routeParams: {| token: string, campaignSlug: string |},
  __: TranslatorProps['__'],
  req: express$Request,
  res: express$Response,
  currentUrl: string
): (dispatch: Dispatch) => ActionReturn {
  const { token, campaignSlug } = routeParams;
  const successUrl = `${currentUrl}/success`;

  return (dispatch: Dispatch) =>
    dispatch(deleteNotificationSubcribersCompaign(token, campaignSlug))
      .then(() => {
        res.redirect(successUrl);
        dispatch(resourceCampaigns.deleteOne.success.getType());
        return Promise.reject(new Error(`Redirect to ${successUrl}`));
      })
      .catch(response => {
        const message =
          response.response.data.message ||
          __('A temporary error occured while sending your confirmation.');
        dispatch(formActions.stopSubmit('UnsubscriptionCampaignForm', message));
        throw new SubmissionError(message);
      });
}
